import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import algosdk from 'algosdk';
import { RootState } from '../../store';

export interface Settings {
  locale?: string;
  showAllTooltips?: boolean;
  showInitModal?: boolean;
  minBalanceInc?: number;
  notificationPosition?: {
    bottom?: string;
    top?: string;
    left: string;
  };
}

export interface Notifications {
  show?: boolean;

  message: string;
}

const initialState = {
  settings: {
    minBalanceInc: 0.001,
    notificationPosition: { bottom: '0vh', left: '50vw' },
    showAllTooltips: true,
  } as Settings,
  params: {} as algosdk.SuggestedParams,
  isAuthenticated: false,
  notifications: {
    show: true,
    message: 'Welcome to Purrser',
  } as Notifications,
  currentToolTip: 0,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppSettings: (state, action: PayloadAction<Settings>) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    setNotifications: (state, action: PayloadAction<Notifications>) => {
      state.notifications = { ...state.notifications, ...action.payload };
    },
    setParams: (state, action: PayloadAction<algosdk.SuggestedParams>) => {
      state.params = action.payload;
    },
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setToolTip: (state, action: PayloadAction<number>) => {
      state.currentToolTip = action.payload;
    },
    setMinBalanceInc: (state, action: PayloadAction<number>) => {
      state.settings.minBalanceInc = action.payload;
    },
  },
});

export const {
  setAppSettings,
  setMinBalanceInc,
  setParams,
  setNotifications,
  setAuthenticated,
  setToolTip,
} = appSlice.actions;

export default appSlice.reducer;

export const selectParams = (state: RootState) => {
  return state.app.params;
};
export const selectSettings = (state: RootState) => {
  return state.app.settings;
};
